<template>
  <el-row class="item-outer" type="flex" justify="space-between">
    <el-menu class="left" @select="leftItemSelect" default-active="0">
      <el-menu-item v-for="(item, index) in leftItems" :key="item.id" :index="index + ''">{{item.name}}</el-menu-item>
    </el-menu>
    <div class="right">
      <div style="display: flex">
        <el-button class="btn_new_job" type="primary" @click="addItem()" icon="circle-plus-filled">新增 </el-button>
      </div>
      <el-table :data="items" tooltip-effect="dark" border stripe height="calc(100% - 70px)"
        row-key="id" default-expand-all v-loading="dataLoading">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column label="操作" width="180" show-overflow-tooltip>
          <template #default="{row}">
            <el-button type="text" @click="editItem(row)">编辑</el-button>
            <el-button type="text" @click="addItem(row.id)">增加下级</el-button>
            <el-button type="text" @click="toDelete(row.id)" style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-row>

  <el-dialog title="新增/编辑字典项" v-model="dialogFormVisible" destroy-on-close>
    <el-form :model="item" :rules="itemRule" ref="itemForm" label-width="120px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="item.name" autocomplete="off" clearable></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="item.sort" autocomplete="off" :step="1" clearable></el-input-number>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button :loading="saveLoading" type="primary" @click="saveItem()">提 交</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import {defineComponent} from 'vue'
  import { getTopItems, getItemByTypeCode, saveOrUpdateItem, deleteItemById } from '@/api/sys/item';
import { deepClone } from '@/utils/common';

  export default defineComponent({
    data() {
      return {
        leftItems: [], // 左侧字典项
        currentItem: null, // 当前选中字典项
        items: [], // 字典项列表
        item: {}, // 新增/编辑的字典项
        itemRule: {
          name: [{required: true, message: "请输入名称", trigger: "blur"}]
        },
        dataLoading: false,
        saveLoading: false,
        dialogFormVisible: false
      }
    },
    mounted() {
      this.getLeftItems();
    },
    methods: {
      getLeftItems() {
        getTopItems().then(({data}) => {
          this.leftItems = data.data;
          this.currentItem = this.leftItems[0];
          this.getData();
        })
      },
      getData() {
        this.dataLoading = true;
        getItemByTypeCode(this.currentItem.typeCode).then(({data}) => {
          this.items = data.data;
          this.dataLoading = false;
        }).catch(_ => this.dataLoading = false);
      },
      addItem(pid) {
        this.item = {
          name: '',
          sort: 99,
          pid: pid || this.currentItem.id
        };
        this.dialogFormVisible = true;
      },
      editItem(item) {
        this.item = deepClone(item);
        this.dialogFormVisible = true;
      },
      saveItem() {
        this.$refs.itemForm.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            saveOrUpdateItem(this.item).then(({data}) => {
              if (data.status) {
                this.$message.success(data.msg);
                this.getData();
                this.dialogFormVisible = false;
              } else {
                this.$message.warning(data.msg);
              }
              this.saveLoading = false;
            }).catch(_ => this.saveLoading = false);
          }
        })
      },
      leftItemSelect(index) {
        this.currentItem = this.leftItems[index];
        this.getData();
      },
      toDelete(id) {
        this.$confirm('确定要删除此字典项', '提示').then(_ => {
          deleteItemById(id).then(({data}) => {
            if (data.status) {
              this.$message.success(data.msg);
              this.getData();
            } else {
              this.$message.warning(data.msg);
            }
          })
        }).catch(_ => {})
      }
    }
  })
</script>

<style lang="scss" scoped>
.item-outer {
  padding-top: 15px;
  .el-menu.left {
    width: 200px;
    height: calc(100vh - 96px);
    overflow-y: auto;
    border-right: 0;
    .el-menu-item.is-active {
      background-color: rgba(237, 243, 255, 0.4196078431372549);
    }
  }
  .right {
    width: calc(100% - 241px);
    padding: 0 20px 20px;
    .el-table {
      margin-top: 15px;
    }
  }
}
</style>
